// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.script.runtime.ObjectValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.IgnitorSlotLike
import io.peekandpoke.klang.script.stdlib.KatalystSlotLike
import io.peekandpoke.klang.sprudel.SprudelPattern
import io.peekandpoke.klang.sprudel.lang.PatternLike
import io.peekandpoke.klang.sprudel.lang.PatternMapperFn
import io.peekandpoke.klang.sprudel.lang.PatternMapperProvider
import io.peekandpoke.klang.sprudel.lang.abs
import io.peekandpoke.klang.sprudel.lang.accelerate
import io.peekandpoke.klang.sprudel.lang.add
import io.peekandpoke.klang.sprudel.lang.adsr
import io.peekandpoke.klang.sprudel.lang.adsrCurves
import io.peekandpoke.klang.sprudel.lang.adsrOff
import io.peekandpoke.klang.sprudel.lang.adsrOn
import io.peekandpoke.klang.sprudel.lang.almostAlways
import io.peekandpoke.klang.sprudel.lang.almostNever
import io.peekandpoke.klang.sprudel.lang.always
import io.peekandpoke.klang.sprudel.lang.analog
import io.peekandpoke.klang.sprudel.lang.and
import io.peekandpoke.klang.sprudel.lang.apply
import io.peekandpoke.klang.sprudel.lang.applyN
import io.peekandpoke.klang.sprudel.lang.arrange
import io.peekandpoke.klang.sprudel.lang.bandpass
import io.peekandpoke.klang.sprudel.lang.bank
import io.peekandpoke.klang.sprudel.lang.beatRate
import io.peekandpoke.klang.sprudel.lang.beats
import io.peekandpoke.klang.sprudel.lang.begin
import io.peekandpoke.klang.sprudel.lang.berlin
import io.peekandpoke.klang.sprudel.lang.binary
import io.peekandpoke.klang.sprudel.lang.binaryL
import io.peekandpoke.klang.sprudel.lang.binaryN
import io.peekandpoke.klang.sprudel.lang.binaryNL
import io.peekandpoke.klang.sprudel.lang.bitAnd
import io.peekandpoke.klang.sprudel.lang.bitOr
import io.peekandpoke.klang.sprudel.lang.bitShl
import io.peekandpoke.klang.sprudel.lang.bitShr
import io.peekandpoke.klang.sprudel.lang.bitXor
import io.peekandpoke.klang.sprudel.lang.bite
import io.peekandpoke.klang.sprudel.lang.bjork
import io.peekandpoke.klang.sprudel.lang.body
import io.peekandpoke.klang.sprudel.lang.bpf
import io.peekandpoke.klang.sprudel.lang.bpfCurves
import io.peekandpoke.klang.sprudel.lang.bpm
import io.peekandpoke.klang.sprudel.lang.brak
import io.peekandpoke.klang.sprudel.lang.brand
import io.peekandpoke.klang.sprudel.lang.brandBy
import io.peekandpoke.klang.sprudel.lang.bypass
import io.peekandpoke.klang.sprudel.lang.cat
import io.peekandpoke.klang.sprudel.lang.ceil
import io.peekandpoke.klang.sprudel.lang.choose
import io.peekandpoke.klang.sprudel.lang.chooseCycles
import io.peekandpoke.klang.sprudel.lang.chooseIn
import io.peekandpoke.klang.sprudel.lang.chooseInWith
import io.peekandpoke.klang.sprudel.lang.chooseOut
import io.peekandpoke.klang.sprudel.lang.chooseWith
import io.peekandpoke.klang.sprudel.lang.chord
import io.peekandpoke.klang.sprudel.lang.chunk
import io.peekandpoke.klang.sprudel.lang.chunkBack
import io.peekandpoke.klang.sprudel.lang.chunkBackInto
import io.peekandpoke.klang.sprudel.lang.chunkInto
import io.peekandpoke.klang.sprudel.lang.chunkback
import io.peekandpoke.klang.sprudel.lang.chunkbackinto
import io.peekandpoke.klang.sprudel.lang.chunkinto
import io.peekandpoke.klang.sprudel.lang.clamp
import io.peekandpoke.klang.sprudel.lang.clip
import io.peekandpoke.klang.sprudel.lang.coarse
import io.peekandpoke.klang.sprudel.lang.comp
import io.peekandpoke.klang.sprudel.lang.compress
import io.peekandpoke.klang.sprudel.lang.compressor
import io.peekandpoke.klang.sprudel.lang.cosine
import io.peekandpoke.klang.sprudel.lang.cps
import io.peekandpoke.klang.sprudel.lang.crush
import io.peekandpoke.klang.sprudel.lang.cull
import io.peekandpoke.klang.sprudel.lang.cut
import io.peekandpoke.klang.sprudel.lang.cylinder
import io.peekandpoke.klang.sprudel.lang.d
import io.peekandpoke.klang.sprudel.lang.degrade
import io.peekandpoke.klang.sprudel.lang.degradeBy
import io.peekandpoke.klang.sprudel.lang.degradeByWith
import io.peekandpoke.klang.sprudel.lang.delay
import io.peekandpoke.klang.sprudel.lang.density
import io.peekandpoke.klang.sprudel.lang.densityGap
import io.peekandpoke.klang.sprudel.lang.distort
import io.peekandpoke.klang.sprudel.lang.div
import io.peekandpoke.klang.sprudel.lang.drop
import io.peekandpoke.klang.sprudel.lang.duck
import io.peekandpoke.klang.sprudel.lang.duty
import io.peekandpoke.klang.sprudel.lang.early
import io.peekandpoke.klang.sprudel.lang.earlyInCycle
import io.peekandpoke.klang.sprudel.lang.echo
import io.peekandpoke.klang.sprudel.lang.echoWith
import io.peekandpoke.klang.sprudel.lang.echowith
import io.peekandpoke.klang.sprudel.lang.eish
import io.peekandpoke.klang.sprudel.lang.end
import io.peekandpoke.klang.sprudel.lang.eq
import io.peekandpoke.klang.sprudel.lang.eqt
import io.peekandpoke.klang.sprudel.lang.euclid
import io.peekandpoke.klang.sprudel.lang.euclidLegato
import io.peekandpoke.klang.sprudel.lang.euclidLegatoRot
import io.peekandpoke.klang.sprudel.lang.euclidRot
import io.peekandpoke.klang.sprudel.lang.euclidish
import io.peekandpoke.klang.sprudel.lang.euclidrot
import io.peekandpoke.klang.sprudel.lang.every
import io.peekandpoke.klang.sprudel.lang.extend
import io.peekandpoke.klang.sprudel.lang.fast
import io.peekandpoke.klang.sprudel.lang.fastChunk
import io.peekandpoke.klang.sprudel.lang.fastGap
import io.peekandpoke.klang.sprudel.lang.fastcat
import io.peekandpoke.klang.sprudel.lang.fastchunk
import io.peekandpoke.klang.sprudel.lang.filterWhen
import io.peekandpoke.klang.sprudel.lang.firstOf
import io.peekandpoke.klang.sprudel.lang.flipSign
import io.peekandpoke.klang.sprudel.lang.floor
import io.peekandpoke.klang.sprudel.lang.fm
import io.peekandpoke.klang.sprudel.lang.focus
import io.peekandpoke.klang.sprudel.lang.freq
import io.peekandpoke.klang.sprudel.lang.gain
import io.peekandpoke.klang.sprudel.lang.gap
import io.peekandpoke.klang.sprudel.lang.gt
import io.peekandpoke.klang.sprudel.lang.gte
import io.peekandpoke.klang.sprudel.lang.highpass
import io.peekandpoke.klang.sprudel.lang.hpf
import io.peekandpoke.klang.sprudel.lang.hpfCurves
import io.peekandpoke.klang.sprudel.lang.hurry
import io.peekandpoke.klang.sprudel.lang.hush
import io.peekandpoke.klang.sprudel.lang.ignitorParam
import io.peekandpoke.klang.sprudel.lang.ignp
import io.peekandpoke.klang.sprudel.lang.inhabit
import io.peekandpoke.klang.sprudel.lang.inhabitmod
import io.peekandpoke.klang.sprudel.lang.inside
import io.peekandpoke.klang.sprudel.lang.inv
import io.peekandpoke.klang.sprudel.lang.invert
import io.peekandpoke.klang.sprudel.lang.irand
import io.peekandpoke.klang.sprudel.lang.iter
import io.peekandpoke.klang.sprudel.lang.iterBack
import io.peekandpoke.klang.sprudel.lang.jux
import io.peekandpoke.klang.sprudel.lang.juxBy
import io.peekandpoke.klang.sprudel.lang.katalyst
import io.peekandpoke.klang.sprudel.lang.katalystParam
import io.peekandpoke.klang.sprudel.lang.katp
import io.peekandpoke.klang.sprudel.lang.lastOf
import io.peekandpoke.klang.sprudel.lang.late
import io.peekandpoke.klang.sprudel.lang.lateInCycle
import io.peekandpoke.klang.sprudel.lang.layer
import io.peekandpoke.klang.sprudel.lang.legato
import io.peekandpoke.klang.sprudel.lang.linger
import io.peekandpoke.klang.sprudel.lang.log2
import io.peekandpoke.klang.sprudel.lang.loop
import io.peekandpoke.klang.sprudel.lang.loopAt
import io.peekandpoke.klang.sprudel.lang.loopAtCps
import io.peekandpoke.klang.sprudel.lang.loopatcps
import io.peekandpoke.klang.sprudel.lang.lowpass
import io.peekandpoke.klang.sprudel.lang.lpf
import io.peekandpoke.klang.sprudel.lang.lpfCurves
import io.peekandpoke.klang.sprudel.lang.lt
import io.peekandpoke.klang.sprudel.lang.lte
import io.peekandpoke.klang.sprudel.lang.mask
import io.peekandpoke.klang.sprudel.lang.maskAll
import io.peekandpoke.klang.sprudel.lang.master
import io.peekandpoke.klang.sprudel.lang.max
import io.peekandpoke.klang.sprudel.lang.merge
import io.peekandpoke.klang.sprudel.lang.min
import io.peekandpoke.klang.sprudel.lang.mini
import io.peekandpoke.klang.sprudel.lang.mod
import io.peekandpoke.klang.sprudel.lang.morse
import io.peekandpoke.klang.sprudel.lang.mul
import io.peekandpoke.klang.sprudel.lang.mute
import io.peekandpoke.klang.sprudel.lang.n
import io.peekandpoke.klang.sprudel.lang.ne
import io.peekandpoke.klang.sprudel.lang.net
import io.peekandpoke.klang.sprudel.lang.never
import io.peekandpoke.klang.sprudel.lang.noCull
import io.peekandpoke.klang.sprudel.lang.not
import io.peekandpoke.klang.sprudel.lang.notch
import io.peekandpoke.klang.sprudel.lang.notchCurves
import io.peekandpoke.klang.sprudel.lang.note
import io.peekandpoke.klang.sprudel.lang.nothing
import io.peekandpoke.klang.sprudel.lang.o
import io.peekandpoke.klang.sprudel.lang.off
import io.peekandpoke.klang.sprudel.lang.often
import io.peekandpoke.klang.sprudel.lang.oneMinusValue
import io.peekandpoke.klang.sprudel.lang.onepole
import io.peekandpoke.klang.sprudel.lang.or
import io.peekandpoke.klang.sprudel.lang.orbit
import io.peekandpoke.klang.sprudel.lang.outside
import io.peekandpoke.klang.sprudel.lang.pace
import io.peekandpoke.klang.sprudel.lang.palindrome
import io.peekandpoke.klang.sprudel.lang.pan
import io.peekandpoke.klang.sprudel.lang.penv
import io.peekandpoke.klang.sprudel.lang.penvCurves
import io.peekandpoke.klang.sprudel.lang.perlin
import io.peekandpoke.klang.sprudel.lang.phaser
import io.peekandpoke.klang.sprudel.lang.pick
import io.peekandpoke.klang.sprudel.lang.pickF
import io.peekandpoke.klang.sprudel.lang.pickOut
import io.peekandpoke.klang.sprudel.lang.pickReset
import io.peekandpoke.klang.sprudel.lang.pickRestart
import io.peekandpoke.klang.sprudel.lang.pickSqueeze
import io.peekandpoke.klang.sprudel.lang.pickmod
import io.peekandpoke.klang.sprudel.lang.pickmodF
import io.peekandpoke.klang.sprudel.lang.pickmodOut
import io.peekandpoke.klang.sprudel.lang.pickmodReset
import io.peekandpoke.klang.sprudel.lang.pickmodRestart
import io.peekandpoke.klang.sprudel.lang.pickmodSqueeze
import io.peekandpoke.klang.sprudel.lang.ply
import io.peekandpoke.klang.sprudel.lang.plyForEach
import io.peekandpoke.klang.sprudel.lang.plyWith
import io.peekandpoke.klang.sprudel.lang.plyforeach
import io.peekandpoke.klang.sprudel.lang.plywith
import io.peekandpoke.klang.sprudel.lang.polymeter
import io.peekandpoke.klang.sprudel.lang.polymeterSteps
import io.peekandpoke.klang.sprudel.lang.polyrhythm
import io.peekandpoke.klang.sprudel.lang.pow
import io.peekandpoke.klang.sprudel.lang.pregain
import io.peekandpoke.klang.sprudel.lang.press
import io.peekandpoke.klang.sprudel.lang.pressBy
import io.peekandpoke.klang.sprudel.lang.pure
import io.peekandpoke.klang.sprudel.lang.rand
import io.peekandpoke.klang.sprudel.lang.randCycle
import io.peekandpoke.klang.sprudel.lang.randcat
import io.peekandpoke.klang.sprudel.lang.randrun
import io.peekandpoke.klang.sprudel.lang.range
import io.peekandpoke.klang.sprudel.lang.rangex
import io.peekandpoke.klang.sprudel.lang.rarely
import io.peekandpoke.klang.sprudel.lang.ratio
import io.peekandpoke.klang.sprudel.lang.repeat
import io.peekandpoke.klang.sprudel.lang.repeatCycles
import io.peekandpoke.klang.sprudel.lang.rest
import io.peekandpoke.klang.sprudel.lang.rev
import io.peekandpoke.klang.sprudel.lang.reverb
import io.peekandpoke.klang.sprudel.lang.revv
import io.peekandpoke.klang.sprudel.lang.rib
import io.peekandpoke.klang.sprudel.lang.ribbon
import io.peekandpoke.klang.sprudel.lang.rootNotes
import io.peekandpoke.klang.sprudel.lang.round
import io.peekandpoke.klang.sprudel.lang.rpm
import io.peekandpoke.klang.sprudel.lang.run
import io.peekandpoke.klang.sprudel.lang.s
import io.peekandpoke.klang.sprudel.lang.s_cat
import io.peekandpoke.klang.sprudel.lang.saw
import io.peekandpoke.klang.sprudel.lang.scale
import io.peekandpoke.klang.sprudel.lang.scaleTranspose
import io.peekandpoke.klang.sprudel.lang.scramble
import io.peekandpoke.klang.sprudel.lang.seed
import io.peekandpoke.klang.sprudel.lang.seg
import io.peekandpoke.klang.sprudel.lang.segment
import io.peekandpoke.klang.sprudel.lang.seq
import io.peekandpoke.klang.sprudel.lang.sequenceP
import io.peekandpoke.klang.sprudel.lang.shuffle
import io.peekandpoke.klang.sprudel.lang.signal
import io.peekandpoke.klang.sprudel.lang.silence
import io.peekandpoke.klang.sprudel.lang.sine
import io.peekandpoke.klang.sprudel.lang.sineOfDay
import io.peekandpoke.klang.sprudel.lang.sineOfNight
import io.peekandpoke.klang.sprudel.lang.slice
import io.peekandpoke.klang.sprudel.lang.slow
import io.peekandpoke.klang.sprudel.lang.slowChunk
import io.peekandpoke.klang.sprudel.lang.slowcat
import io.peekandpoke.klang.sprudel.lang.slowcatPrime
import io.peekandpoke.klang.sprudel.lang.slowchunk
import io.peekandpoke.klang.sprudel.lang.sndBrown
import io.peekandpoke.klang.sprudel.lang.sndCrackle
import io.peekandpoke.klang.sprudel.lang.sndDust
import io.peekandpoke.klang.sprudel.lang.sndNoise
import io.peekandpoke.klang.sprudel.lang.sndPink
import io.peekandpoke.klang.sprudel.lang.sndPluck
import io.peekandpoke.klang.sprudel.lang.sndPulze
import io.peekandpoke.klang.sprudel.lang.sndRamp
import io.peekandpoke.klang.sprudel.lang.sndSaw
import io.peekandpoke.klang.sprudel.lang.sndSine
import io.peekandpoke.klang.sprudel.lang.sndSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperPluck
import io.peekandpoke.klang.sprudel.lang.sndSuperRamp
import io.peekandpoke.klang.sprudel.lang.sndSuperSaw
import io.peekandpoke.klang.sprudel.lang.sndSuperSine
import io.peekandpoke.klang.sprudel.lang.sndSuperSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperTri
import io.peekandpoke.klang.sprudel.lang.sndTri
import io.peekandpoke.klang.sprudel.lang.sndZamp
import io.peekandpoke.klang.sprudel.lang.solo
import io.peekandpoke.klang.sprudel.lang.someCycles
import io.peekandpoke.klang.sprudel.lang.someCyclesBy
import io.peekandpoke.klang.sprudel.lang.sometimes
import io.peekandpoke.klang.sprudel.lang.sometimesBy
import io.peekandpoke.klang.sprudel.lang.sound
import io.peekandpoke.klang.sprudel.lang.speed
import io.peekandpoke.klang.sprudel.lang.splice
import io.peekandpoke.klang.sprudel.lang.square
import io.peekandpoke.klang.sprudel.lang.squeeze
import io.peekandpoke.klang.sprudel.lang.stack
import io.peekandpoke.klang.sprudel.lang.stackBy
import io.peekandpoke.klang.sprudel.lang.stackCentre
import io.peekandpoke.klang.sprudel.lang.stackLeft
import io.peekandpoke.klang.sprudel.lang.stackRight
import io.peekandpoke.klang.sprudel.lang.steady
import io.peekandpoke.klang.sprudel.lang.stepcat
import io.peekandpoke.klang.sprudel.lang.steps
import io.peekandpoke.klang.sprudel.lang.stretchBy
import io.peekandpoke.klang.sprudel.lang.struct
import io.peekandpoke.klang.sprudel.lang.structAll
import io.peekandpoke.klang.sprudel.lang.stut
import io.peekandpoke.klang.sprudel.lang.stutWith
import io.peekandpoke.klang.sprudel.lang.stutwith
import io.peekandpoke.klang.sprudel.lang.sub
import io.peekandpoke.klang.sprudel.lang.superimpose
import io.peekandpoke.klang.sprudel.lang.swing
import io.peekandpoke.klang.sprudel.lang.swingBy
import io.peekandpoke.klang.sprudel.lang.tag
import io.peekandpoke.klang.sprudel.lang.take
import io.peekandpoke.klang.sprudel.lang.time
import io.peekandpoke.klang.sprudel.lang.timeCat
import io.peekandpoke.klang.sprudel.lang.timeLoop
import io.peekandpoke.klang.sprudel.lang.timeOfDay
import io.peekandpoke.klang.sprudel.lang.timeOfNight
import io.peekandpoke.klang.sprudel.lang.timecat
import io.peekandpoke.klang.sprudel.lang.transpose
import io.peekandpoke.klang.sprudel.lang.tremolo
import io.peekandpoke.klang.sprudel.lang.tri
import io.peekandpoke.klang.sprudel.lang.tweak
import io.peekandpoke.klang.sprudel.lang.tweaks
import io.peekandpoke.klang.sprudel.lang.undegrade
import io.peekandpoke.klang.sprudel.lang.undegradeBy
import io.peekandpoke.klang.sprudel.lang.undegradeByWith
import io.peekandpoke.klang.sprudel.lang.uni
import io.peekandpoke.klang.sprudel.lang.unison
import io.peekandpoke.klang.sprudel.lang.unit
import io.peekandpoke.klang.sprudel.lang.vel
import io.peekandpoke.klang.sprudel.lang.velocity
import io.peekandpoke.klang.sprudel.lang.vib
import io.peekandpoke.klang.sprudel.lang.vibrato
import io.peekandpoke.klang.sprudel.lang.voicing
import io.peekandpoke.klang.sprudel.lang.vowel
import io.peekandpoke.klang.sprudel.lang.wchoose
import io.peekandpoke.klang.sprudel.lang.wchooseCycles
import io.peekandpoke.klang.sprudel.lang.`when`
import io.peekandpoke.klang.sprudel.lang.withSeed
import io.peekandpoke.klang.sprudel.lang.within
import io.peekandpoke.klang.sprudel.lang.wrandcat
import io.peekandpoke.klang.sprudel.lang.zoom
import kotlin.Function1

internal fun KlangScriptExtensionBuilder.registerSprudelLangSynthesisChunk0() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "fm",
        paramSpecs = listOf(
            ParamSpec(name = "depth", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fm", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.fm(
                depth = optArg(args, 0, Any::class, loc),
                ratio = optArg(args, 1, Any::class, loc),
                attack = optArg(args, 2, Any::class, loc),
                decay = optArg(args, 3, Any::class, loc),
                sustain = optArg(args, 4, Any::class, loc),
                release = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "fm",
        paramSpecs = listOf(
            ParamSpec(name = "depth", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fm", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.fm(
                depth = optArg(args, 0, Any::class, loc),
                ratio = optArg(args, 1, Any::class, loc),
                attack = optArg(args, 2, Any::class, loc),
                decay = optArg(args, 3, Any::class, loc),
                sustain = optArg(args, 4, Any::class, loc),
                release = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "fm",
        paramSpecs = listOf(
            ParamSpec(name = "depth", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fm", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.fm(
                depth = optArg(args, 0, Any::class, loc),
                ratio = optArg(args, 1, Any::class, loc),
                attack = optArg(args, 2, Any::class, loc),
                decay = optArg(args, 3, Any::class, loc),
                sustain = optArg(args, 4, Any::class, loc),
                release = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("fm") on fm
    registerObject("fm", fm) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "depth", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "decay", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "sustain", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "fm", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                fm.invoke(
                    depth = optArg(args, 0, Any::class, loc),
                    ratio = optArg(args, 1, Any::class, loc),
                    attack = optArg(args, 2, Any::class, loc),
                    decay = optArg(args, 3, Any::class, loc),
                    sustain = optArg(args, 4, Any::class, loc),
                    release = optArg(args, 5, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
        registerProperty("depth") { fm.depth }
        registerProperty("ratio") { fm.ratio }
        registerProperty("attack") { fm.attack }
        registerProperty("decay") { fm.decay }
        registerProperty("sustain") { fm.sustain }
        registerProperty("release") { fm.release }
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "ignitorParam",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignitorParam", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignitorParam", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignitorParam", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignitorParam(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "ignitorParam",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignitorParam", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignitorParam", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignitorParam", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignitorParam(slot = slot, value = value, callInfo = callInfo))
    }

    // @Function on ignitorParam
    registerFunctionWithSpecs(
        name = "ignitorParam",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "ignitorParam", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignitorParam", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignitorParam", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(ignitorParam(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "ignitorParam",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignitorParam", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignitorParam", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignitorParam", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignitorParam(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "ignp",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignp", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignp", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignp", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignp(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "ignp",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignp", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignp", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignp", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignp(slot = slot, value = value, callInfo = callInfo))
    }

    // @Function on ignp
    registerFunctionWithSpecs(
        name = "ignp",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "ignp", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignp", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignp", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(ignp(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "ignp",
        paramSpecs = listOf(
            ParamSpec(name = "slot", kotlinType = Any::class, isNullable = true),
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ignp", args = args, expected = 2, location = loc)
        val slot = convertArgToKotlin(fn = "ignp", args = args, index = 0, cls = Any::class, nullable = true, loc = loc)
        val value = convertArgToKotlin(fn = "ignp", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.ignp(slot = slot, value = value, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "analog", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.analog(
                character = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "analog", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.analog(
                character = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("analog") on analog
    registerObject("analog", analog) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "character", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "analog", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                analog.invoke(
                    character = optArg(args, 0, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "analog",
        paramSpecs = listOf(
            ParamSpec(name = "character", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "analog", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.analog(
                character = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "duty", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.duty(
                width = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "duty", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.duty(
                width = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangSynthesisChunk1() {

    // @Object("duty") on duty
    registerObject("duty", duty) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "width", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "duty", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                duty.invoke(
                    width = optArg(args, 0, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "duty", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.duty(
                width = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "onepole",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "onepole", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.onepole(
                freq = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "onepole",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "onepole", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.onepole(
                freq = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Object("onepole") on onepole
    registerObject("onepole", onepole) {
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "__invoke__",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            val callInfo = callInfoOf(receiver, args, loc)
            checkArgsSize(fn = "onepole", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                onepole.invoke(
                    freq = optArg(args, 0, Any::class, loc),
                    callInfo = callInfo,
                )
            )
        }
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "onepole",
        paramSpecs = listOf(
            ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "onepole", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.onepole(
                freq = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSine",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSine(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSine",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSine(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSine
    registerFunctionWithSpecs(
        name = "sndSine",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSine(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSine",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSine(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSaw",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSaw(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSaw",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSaw(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSaw
    registerFunctionWithSpecs(
        name = "sndSaw",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSaw(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSaw",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSaw(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSquare",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSquare(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSquare",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSquare(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSquare
    registerFunctionWithSpecs(
        name = "sndSquare",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSquare(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSquare",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSquare(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndTri",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndTri(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndTri",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndTri(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndTri
    registerFunctionWithSpecs(
        name = "sndTri",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndTri(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndTri",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndTri(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndRamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndRamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndRamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndRamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndRamp
    registerFunctionWithSpecs(
        name = "sndRamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndRamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndRamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndRamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangSynthesisChunk2() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndZamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndZamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndZamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndZamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndZamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndZamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndZamp
    registerFunctionWithSpecs(
        name = "sndZamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndZamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndZamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndZamp",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndZamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndZamp(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndNoise",
        paramSpecs = listOf(
            ParamSpec(name = "color", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndNoise", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndNoise(
                color = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndNoise",
        paramSpecs = listOf(
            ParamSpec(name = "color", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndNoise", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndNoise(
                color = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndNoise
    registerFunctionWithSpecs(
        name = "sndNoise",
        paramSpecs = listOf(
            ParamSpec(name = "color", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndNoise", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndNoise(
                color = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndNoise",
        paramSpecs = listOf(
            ParamSpec(name = "color", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndNoise", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndNoise(
                color = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndBrown",
        paramSpecs = listOf(
            ParamSpec(name = "leak", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndBrown", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndBrown(
                leak = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndBrown",
        paramSpecs = listOf(
            ParamSpec(name = "leak", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndBrown", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndBrown(
                leak = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndBrown
    registerFunctionWithSpecs(
        name = "sndBrown",
        paramSpecs = listOf(
            ParamSpec(name = "leak", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndBrown", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndBrown(
                leak = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndBrown",
        paramSpecs = listOf(
            ParamSpec(name = "leak", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndBrown", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndBrown(
                leak = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndPink",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPink", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPink(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndPink",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPink", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPink(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndPink
    registerFunctionWithSpecs(
        name = "sndPink",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndPink", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndPink(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndPink",
        paramSpecs = listOf(
            ParamSpec(name = "params", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPink", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPink(
                params = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndPulze",
        paramSpecs = listOf(
            ParamSpec(name = "duty", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPulze", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPulze(
                duty = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndPulze",
        paramSpecs = listOf(
            ParamSpec(name = "duty", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPulze", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPulze(
                duty = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndPulze
    registerFunctionWithSpecs(
        name = "sndPulze",
        paramSpecs = listOf(
            ParamSpec(name = "duty", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndPulze", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndPulze(
                duty = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndPulze",
        paramSpecs = listOf(
            ParamSpec(name = "duty", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPulze", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPulze(
                duty = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndDust",
        paramSpecs = listOf(
            ParamSpec(name = "density", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "tail", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndDust", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndDust(
                density = optArg(args, 0, Any::class, loc),
                tail = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndDust",
        paramSpecs = listOf(
            ParamSpec(name = "density", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "tail", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndDust", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndDust(
                density = optArg(args, 0, Any::class, loc),
                tail = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndDust
    registerFunctionWithSpecs(
        name = "sndDust",
        paramSpecs = listOf(
            ParamSpec(name = "density", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "tail", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndDust", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndDust(
                density = optArg(args, 0, Any::class, loc),
                tail = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndDust",
        paramSpecs = listOf(
            ParamSpec(name = "density", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "tail", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndDust", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndDust(
                density = optArg(args, 0, Any::class, loc),
                tail = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndCrackle",
        paramSpecs = listOf(
            ParamSpec(name = "chaos", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndCrackle", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndCrackle(
                chaos = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangSynthesisChunk3() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndCrackle",
        paramSpecs = listOf(
            ParamSpec(name = "chaos", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndCrackle", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndCrackle(
                chaos = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndCrackle
    registerFunctionWithSpecs(
        name = "sndCrackle",
        paramSpecs = listOf(
            ParamSpec(name = "chaos", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndCrackle", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndCrackle(
                chaos = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndCrackle",
        paramSpecs = listOf(
            ParamSpec(name = "chaos", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndCrackle", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndCrackle(
                chaos = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndPluck",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPluck(
                feedback = optArg(args, 0, Any::class, loc),
                brightness = optArg(args, 1, Any::class, loc),
                pickPosition = optArg(args, 2, Any::class, loc),
                stiffness = optArg(args, 3, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndPluck",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPluck(
                feedback = optArg(args, 0, Any::class, loc),
                brightness = optArg(args, 1, Any::class, loc),
                pickPosition = optArg(args, 2, Any::class, loc),
                stiffness = optArg(args, 3, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndPluck
    registerFunctionWithSpecs(
        name = "sndPluck",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndPluck(
                feedback = optArg(args, 0, Any::class, loc),
                brightness = optArg(args, 1, Any::class, loc),
                pickPosition = optArg(args, 2, Any::class, loc),
                stiffness = optArg(args, 3, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndPluck",
        paramSpecs = listOf(
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndPluck(
                feedback = optArg(args, 0, Any::class, loc),
                brightness = optArg(args, 1, Any::class, loc),
                pickPosition = optArg(args, 2, Any::class, loc),
                stiffness = optArg(args, 3, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperPluck",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperPluck(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                feedback = optArg(args, 2, Any::class, loc),
                brightness = optArg(args, 3, Any::class, loc),
                pickPosition = optArg(args, 4, Any::class, loc),
                stiffness = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperPluck",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperPluck(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                feedback = optArg(args, 2, Any::class, loc),
                brightness = optArg(args, 3, Any::class, loc),
                pickPosition = optArg(args, 4, Any::class, loc),
                stiffness = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperPluck
    registerFunctionWithSpecs(
        name = "sndSuperPluck",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperPluck(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                feedback = optArg(args, 2, Any::class, loc),
                brightness = optArg(args, 3, Any::class, loc),
                pickPosition = optArg(args, 4, Any::class, loc),
                stiffness = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperPluck",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "brightness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "pickPosition", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "stiffness", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperPluck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperPluck(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                feedback = optArg(args, 2, Any::class, loc),
                brightness = optArg(args, 3, Any::class, loc),
                pickPosition = optArg(args, 4, Any::class, loc),
                stiffness = optArg(args, 5, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperSaw",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSaw(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperSaw",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSaw(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperSaw
    registerFunctionWithSpecs(
        name = "sndSuperSaw",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperSaw(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperSaw",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSaw", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSaw(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperSine",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSine(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangSynthesisChunk4() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperSine",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSine(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperSine
    registerFunctionWithSpecs(
        name = "sndSuperSine",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperSine(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperSine",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSine", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSine(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperSquare",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSquare(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperSquare",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSquare(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperSquare
    registerFunctionWithSpecs(
        name = "sndSuperSquare",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperSquare(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperSquare",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperSquare", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperSquare(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperTri",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperTri(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperTri",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperTri(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperTri
    registerFunctionWithSpecs(
        name = "sndSuperTri",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperTri(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperTri",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperTri", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperTri(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "sndSuperRamp",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperRamp(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "sndSuperRamp",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperRamp(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on sndSuperRamp
    registerFunctionWithSpecs(
        name = "sndSuperRamp",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "sndSuperRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            sndSuperRamp(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "sndSuperRamp",
        paramSpecs = listOf(
            ParamSpec(name = "voices", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "spread", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "sndSuperRamp", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.sndSuperRamp(
                voices = optArg(args, 0, Any::class, loc),
                spread = optArg(args, 1, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }
}

